import {Link} from "react-router";

import {ServiceUsage} from "@/lib/types/checks.ts";

interface InstantCheckoutRequestFailureProps {
  serviceUsage: ServiceUsage;
}

export const InstantCheckoutRequestFailure = ({serviceUsage}: InstantCheckoutRequestFailureProps) => (
  <small>
    <p>
      There was a <strong>problem</strong> sending the purchase request.
    </p>
    <p>
      You have reached the maximum number of <strong>{serviceUsage.limit_name}</strong> Checks available in your
      account.
    </p>
    <p>
      If you have any questions don’t hesitate to <Link to="/contact">contact us</Link>.
    </p>
  </small>
);
